import { Form, Input, Modal } from 'antd'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

const CreateFolderModal = ({ visible, onClose, onConfirm, form }) => {
  const { t } = useTranslation()
  return (
    <Modal
      title={t('ACTION_CREATE_FOLDER')}
      visible={visible}
      onCancel={onClose}
      okText={t('ACTION_CREATE')}
      onOk={onConfirm}
      cancelText={t('ACTION_CANCEL')}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          label={t('FIELD_NAME')}
          name="name"
          rules={[{ required: true, message: t('REQUIRED_FIELD') }]}
        >
          <Input placeholder={t('ACTION_ENTER')} />
        </Form.Item>
      </Form>
    </Modal>
  )
}

CreateFolderModal.propTypes = {
  form: PropTypes.any,
  visible: PropTypes.bool,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
}

export default CreateFolderModal
